import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-duet',
  templateUrl: './icon-duet.component.html',
  styleUrls: ['./icon-duet.component.scss']
})
export class IconDuetComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
